import { FilePicker } from "@capawesome/capacitor-file-picker";
import { TextFieldTypes } from "@ionic/core";
import {
  IonAccordion,
  IonButton,
  IonCol,
  IonGrid,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonRow,
  IonText,
} from "@ionic/react";
import { useEffect, useState } from "react";
import { isAndroid, isBrowser } from "react-device-detect";
import { makeGETRequest, makePATCHRequest } from "../../../request/rawRequest";
import { Input } from "../../../types/input";
import { uploadFileToIos } from "../../../utils/uploadImageToIOS";
import { uploadFileOnAWS } from "../../../variables/s3Variables";

interface Props {}

const UpdateUser: React.FC<Props> = ({}) => {
  const [inputs, setInputs] = useState<Input[]>([]);
  const [file, setFile] = useState<File>();

  const valued = async () => {
    let temp: Input[] = [];
    await makeGETRequest("/me").then((response) => {
      const InputsDefault: Input[] = [
        { name: "Nom", value: response.last_name, type: "text", change: false },
        {
          name: "Prénom",
          value: response.first_name,
          type: "text",
          change: false,
        },
        {
          name: "Téléphone",
          value: response.phone_number,
          type: "tel",
          change: false,
        },
        { name: "Email", value: response.email, type: "email", change: false },
        { name: "_id", value: response._id, type: "text", change: false },
      ];
      temp = InputsDefault;
    });
    return temp;
  };

  const fetchInfos = () => {
    valued().then((response) => {
      setInputs(response);
    });
  };

  const resetFormAccount = () => {
    fetchInfos();
    setFile(undefined);
  };

  const getFileToUpload = async () => {
    await FilePicker.pickFiles({
      multiple: false,
      types: ["image/*"],
    }).then((e) => {
      setFile(new File([e.files[0].blob ?? ""], e.files[0].name));
    });
  };

  const updateUser = (
    last_name: string,
    first_name: string,
    phone_number: string,
    picture_url?: string
  ) => {
    makeGETRequest("/me").then(async (response) => {
      makePATCHRequest("/user?_id=" + response._id, {
        last_name,
        first_name,
        phone_number,
        picture_url: picture_url ?? response.picture_url,
      }).then(() => {
        window.location.reload();
        resetFormAccount();
      });
    });
  };

  const handleClick = () => {
    if (file) {
      uploadFileOnAWS("pictureFolder", file).then((uploadedFile) =>
        updateUser(
          inputs[0].value.toString(),
          inputs[1].value.toString(),
          inputs[2].value.toString(),
          uploadedFile.location
        )
      );
    } else {
      updateUser(
        inputs[0].value.toString(),
        inputs[1].value.toString(),
        inputs[2].value.toString()
      );
    }
  };

  useEffect(() => {
    fetchInfos();
  }, []);

  return (
    <IonAccordion style={{ borderRadius: 20, marginTop: 10 }}>
      <IonItem slot="header">
        <IonLabel>Modifier mes informations</IonLabel>
      </IonItem>
      <div className="ion-padding" slot="content">
        <IonList>
          {inputs.map((input, i) => {
            return input.name !== "_id" ? (
              <IonItem key={i}>
                <IonLabel position="stacked" color="black">
                  {input.name}
                </IonLabel>
                <IonInput
                  value={input.value}
                  type={input.type as TextFieldTypes}
                  onKeyUp={(e) => {
                    setInputs((old) => [
                      ...old.slice(0, i),
                      {
                        ...old[i],
                        change: true,
                        value: (e.target as HTMLInputElement).value!,
                      },
                      ...old.slice(i + 1, old.length),
                    ]);
                  }}
                ></IonInput>
              </IonItem>
            ) : null;
          })}
          <>
            {isAndroid || isBrowser ? (
              <div>
                <label
                  htmlFor="upload-photo"
                  style={{
                    cursor: "pointer",
                    border: "solid 2px var(--ion-color-primary-contrast)",
                    borderRadius: 20,
                    padding: 5,
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    boxShadow: "0px 5px 5px -3px rgba(0,0,0,0.75)",
                  }}
                >
                  Choisir une image de profile
                </label>
                <input
                  type="file"
                  accept="image/png, image/gif, image/jpeg"
                  multiple={false}
                  name="photo"
                  id="upload-photo"
                  style={{
                    opacity: "0",
                    position: "absolute",
                    zIndex: "-1",
                  }}
                  onChange={(e) => {
                    const file = e.target.files?.item(0);
                    if (file !== null && file !== undefined) {
                      setFile(file);
                    }
                  }}
                />
              </div>
            ) : (
              <IonButton
                fill="solid"
                shape="round"
                expand="full"
                style={{
                  "--border-color": "var(--ion-color-primary-contrast)",
                  "--border-style": "solid",
                  "--border-width": "2px",
                }}
                onClick={() => {
                  uploadFileToIos(setFile);
                }}
              >
                Choisir une image de profile
              </IonButton>
            )}
          </>
          {/* <IonButton onClick={getFileToUpload}>
            Choisir une image de profile
          </IonButton> */}
          <IonGrid>
            <IonRow className="ion-justify-content-center">
              <IonCol
                size="12"
                sizeSm="12"
                sizeLg="6"
                className="ion-justify-content-center"
              >
                <IonText
                  className="btn fullWidth ion-justify-content-center flex"
                  onClick={handleClick}
                >
                  Changez vos informations
                </IonText>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonList>
      </div>
    </IonAccordion>
  );
};

export default UpdateUser;
